module.exports = __webpack_public_path__ + "img/mobile-screenshots.4fdffce4.webp";